export interface HearingTestState {
  currentStep: number;
  profile: UserProfile;
  testData: TestData;
  results: TestResults | null;
  isCompleted: boolean;
}

export interface UserProfile {
  gender: 'male' | 'female' | 'prefer-not-to-say' | null;
  birthYear: number | null;
  hearingLevel: 1 | 2 | 3 | 4 | null; // 1=very poor, 2=poor, 3=good, 4=very good
  difficultySituations: string[];
  designImportance: 1 | 2 | 3 | 4 | null; // 1=strongly disagree, 4=strongly agree
  comfortImportance: 1 | 2 | 3 | 4 | null;
  wearingSituation: 'as-needed' | 'convenient' | 'all-day' | 'idontknow' | null;
}

export interface TestData {
  leftEarScores: number[];
  rightEarScores: number[];
}

export interface TestResults {
  leftEarAverage: number;
  rightEarAverage: number;
  overallSeverityLevel: 'good' | 'moderate' | 'severe';
  leftEarSeverity: 'good' | 'moderate' | 'severe';
  rightEarSeverity: 'good' | 'moderate' | 'severe';
}

export type HearingTestAction =
  | { type: 'NEXT_STEP' }
  | { type: 'PREVIOUS_STEP' }
  | { type: 'GO_TO_STEP'; payload: number }
  | { type: 'UPDATE_PROFILE'; payload: Partial<UserProfile> }
  | {
      type: 'SAVE_FREQUENCY_SCORE';
      payload: { ear: 'left' | 'right'; frequency: FREQUENCIES; score: number };
    }
  | { type: 'CALCULATE_RESULTS'; payload: TestResults }
  | { type: 'LOAD_STATE'; payload: HearingTestState }
  | { type: 'RETAKE_AUDIO_TEST' }
  | { type: 'RESTART_TEST' };

export enum FREQUENCIES {
  HZ_500 = 500,
  HZ_1000 = 1000,
  HZ_2000 = 2000,
  HZ_4000 = 4000,
}

export const STEP_NAMES = {
  INTRODUCTION: 0,
  GENERAL_QUESTIONS: 1,
  LIFESTYLE_QUESTIONS_1: 2,
  LIFESTYLE_QUESTIONS_2: 3,
  SOUND_CHECK: 4,
  LEFT_EAR_INTRO: 5,
  LEFT_500HZ: 6,
  LEFT_1000HZ: 7,
  LEFT_2000HZ: 8,
  LEFT_4000HZ: 9,
  RIGHT_EAR_INTRO: 10,
  RIGHT_500HZ: 11,
  RIGHT_1000HZ: 12,
  RIGHT_2000HZ: 13,
  RIGHT_4000HZ: 14,
  RESULTS: 15,
} as const;

export const TOTAL_STEPS = Object.keys(STEP_NAMES).length;

export const DIFFICULTY_SITUATIONS = [
  'socialgatherings',
  'restaurants',
  'noisyenvironments',
  'meetingswork',
  'television',
  'onphone',
  'idontknow',
] as const;
